export * from "./memory-detail-card"